// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import UserSettingsSidebar from './user_settings_sidebar';

export default UserSettingsSidebar;
